import type { ProjectRow, SavedFilterCriteria, SavedFilterRow } from '@/types/api'

export type TicketsNavState = {
  urlProject: string
  urlStatus: string
  urlFilterName: string
  isTicketsPage: boolean
  isAllTicketsActive: boolean
}

export function getTicketsNavState(pathname: string, search: string): TicketsNavState {
  const params = new URLSearchParams(search)
  const urlProject = params.get('project') || ''
  const urlStatus = params.get('status') || ''
  const urlFilterName = params.get('filter_name') || ''
  const isTicketsPage = pathname === '/tickets'
  const isAllTicketsActive = isTicketsPage && !urlProject && !urlFilterName
  return { urlProject, urlStatus, urlFilterName, isTicketsPage, isAllTicketsActive }
}

function normalizeIdList(v: unknown): string[] {
  if (v == null || v === '') return []
  if (Array.isArray(v)) return v.map(String).filter(Boolean)
  return [String(v)]
}

/** Query string для `/tickets` — как `applyFilter` в classic `Filters.js`. */
export function buildSavedFilterSearch(
  filter: SavedFilterRow,
  projects: ProjectRow[],
): string {
  const params = new URLSearchParams()
  const c = filter.criteria as SavedFilterCriteria

  const status = c.status
  if (Array.isArray(status) && status.length) {
    params.set('status', status.map(String).join(','))
  }
  const priority = c.priority
  if (Array.isArray(priority) && priority.length) {
    params.set('priority', priority.map(String).join(','))
  }

  const projectIds = normalizeIdList(c.project_id)
  if (projectIds.length === 1) {
    const p = projects.find((x) => x.id === projectIds[0])
    params.set('project', p?.slug || projectIds[0])
  } else if (projectIds.length > 1) {
    params.set('project_id', projectIds.join(','))
  }

  const assignedIds = normalizeIdList(c.assigned_to)
  if (assignedIds.length) {
    params.set('assigned_to_id', assignedIds.join(','))
  }

  if (c.unassigned === true) {
    params.set('assigned', 'false')
  }

  if (typeof c.created_within_hours === 'number' && c.created_within_hours >= 1) {
    params.set('created_within_hours', String(c.created_within_hours))
  }
  if (typeof c.updated_within_hours === 'number' && c.updated_within_hours >= 1) {
    params.set('updated_within_hours', String(c.updated_within_hours))
  }

  params.set('filter_name', filter.name)
  return params.toString()
}
